import React, { useEffect, Fragment } from "react";
import Slider   from "../../components/Slider";
import Stage    from "../../components/Stage";
import Header   from "../../components/layout/Header";
import Banner   from "../../components/Banner";


import { useDispatch }              from "react-redux";
import { 
    setCategoriasAction
}                                               from "../../actions/searchActions";

import { 
    getCategoriasR as getCats,
    getArticulosR as getArts,
    jsonDeserialize
}   from "../../API/request";
import Loading from "../../components/Loading";
import BtnSubir from "../../components/BtnSubir";


const Home = () => {
    const dispatch = useDispatch();
    const showPrice = process.env.REACT_APP_SHOW_PRICE  === 'false' ? false : true;
    const showBanner = process.env.REACT_APP_SHOW_BANNER  === 'false' ? false : true;

    const [showLoading, setShowLoading] = React.useState(true);
    const [listadoCategorias, setListadoCategorias] = React.useState(null);

    const [listadoNuevos, setListadoNuevos] = React.useState([]);
    const [listadoDestacados, setListadoDestacados] = React.useState([]);

    useEffect(() => {
        document.title = "Home";
        window.scrollTo(0, 0)

        setListadoCategorias(null);
        setListadoNuevos([]);
        setListadoDestacados([]);
        
        var generalNuevos = [];
        var generalDestacados = [];

        getCats()
            .then( ( responseCategorias ) => {
                let cats = jsonDeserialize(responseCategorias.data.data).data;
                setListadoCategorias(cats); 
                dispatch(setCategoriasAction(cats));

                let catsS = jsonDeserialize(responseCategorias.data.data).data;
                let catsSortOne = catsS.sort((a, b) => 0.5 - Math.random()).slice(0, 1);

                getArts(catsSortOne[0].idCategoria)
                .then( ( responseArticulos ) => {
                    var arts = jsonDeserialize(responseArticulos.data.data).articulos.data;
                    var item_generalNuevos = arts.filter( (item) =>  item.nuevo === "True");
                    var item_generalDestacados = arts.filter( (item) =>  item.destacado === "True");

                    generalNuevos.push.apply(generalNuevos, item_generalNuevos);
                    generalDestacados.push.apply(generalDestacados, item_generalDestacados);

                    setListadoNuevos(generalNuevos);
                    setListadoDestacados(generalDestacados);
                    setShowLoading(false);

                    window.scrollTo(0, 0)
                })
                .catch((errorMessageGetMantenimiento)=>{
                    console.log("ERORR - En la petición")
                })
            })
            .catch((errorMessageGetMantenimiento)=>{
                console.log("ERORR - En la petición")
            });
    }, [dispatch,setShowLoading,setListadoCategorias,setListadoNuevos,setListadoDestacados]);

    return (
        <Fragment>
            {
                showLoading
                ?   <Loading/>
                :   <>
                        <Header/>
                        <div className="content">
                            {
                                showBanner &&
                                    <Banner/>
                            }
                            {
                                listadoCategorias !== null &&
                                    listadoCategorias.map( (collectionDetail, i) =>
                                        <Stage 
                                            type="Collection"
                                            title={collectionDetail.nombre}
                                            description={collectionDetail.descripcion}
                                            image={ collectionDetail.img}
                                            idCollection={collectionDetail.idCategoria}
                                            key={ "stIt_" + i }
                                        />
                                    )
                            }
                            {
                                listadoNuevos.length > 0 &&
                                    <Slider
                                        title="Nuevos"
                                        articulos={listadoNuevos}
                                        showPrice={showPrice}
                                        showTallas={false}
                                    />
                            }   
                            {
                                listadoDestacados.length > 0 &&
                                    <Slider
                                        title="Destacados"
                                        articulos={listadoDestacados}
                                        showPrice={showPrice}
                                        showTallas={false}
                                    />
                            } 
                        </div>
                        <BtnSubir />
                    </>
            }
        </Fragment>
    );
};

export default Home;
